import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { injectIntl, FormattedMessage } from 'react-intl';

import Container from 'components/Container';
import GetStarted from 'components/GetStarted';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Heading from 'components/Heading';

import { COLOR, FONT_SIZES, FONT_FAMILIES } from 'config';

const termsContainerStyle = {
  marginTop: '32px',
};

const termsStyle = {
  fontFamily: FONT_FAMILIES.sans,
  fontSize: `${FONT_SIZES[2]}px`,
  marginBottom: '50px',
  lineHeight: '1.75rem',
};

const CookiesTerms = ({ intl }) => (
  <div>
    <Helmet>
      <title>{intl.formatMessage({ id: 'cookiesTerms.title' })}</title>
    </Helmet>
    <Header />

    <Container style={termsContainerStyle}>
      <Heading heavy as="h2" fontSize={[6, 7]} color={COLOR.textDark} mb={2}>
        <FormattedMessage id="cookiesTerms.title" />
      </Heading>

      <div style={termsStyle}>
        <FormattedMessage id="cookiesTerms.content" />
      </div>
    </Container>

    <GetStarted />
    <Footer />
  </div>
);

CookiesTerms.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(CookiesTerms);



// WEBPACK FOOTER //
// ./src/components/CookiesTerms/CookiesTerms.js